import React, { useEffect, useState } from "react"
import { gql, useQuery } from "@apollo/client"
import PPLoadingIndicator from "../components/layout/PPLoadingIndicator"
import { PPPresetView } from "../components/pricetable/PPPresetView"
import { PPPresetSelector } from "../components/pricetable/PPPresetSelector"
import PPPriceSettings from "../components/settings/PPPriceSettings"
import { useAuth } from "../hooks/use-auth"
import { useTranslation } from "react-i18next"
import { PPUserSettings } from "../components/settings/PPUserSettings"

const SETTINGS_QUERY = gql`
    query getDataForSettings($userId: Long!) {
        shops {
            id
            name
            lang
            domain
            shouldBeActive
            active
            deactivationTime
            deactivationReason
        }
        settings {
            presets {
                label: name
                value: id
            }
        }
        user(userId: $userId) {
            name
            defaultPresetId: configShowTablePreset
        }
    }
`

export default function PPSettings(props) {
    const auth = useAuth()

    const [refetchPreset, setRefetchPreset] = useState()

    const { loading, data, refetch } = useQuery(SETTINGS_QUERY, {
        variables: { userId: auth.login.user.id },
        fetchPolicy: "no-cache"
    })

    useEffect(() => {
        if (props.presetId === null || props.presetId === undefined) {
            props.changePresetId(data?.settings?.presets[0]?.value)
        }
    }, [data])

    if (loading) return <PPLoadingIndicator />

    return (
        <div>
            <PPUserSettings
                presets={data?.settings?.presets}
                defaultPresetId={data?.user?.defaultPresetId}
                refetchSettingsData={refetch}
                setDataCurrentAuth={props.setDataCurrentAuth}
                refetchPreset={refetchPreset}
            />
            <PresetSettings
                presetId={props.presetId}
                changePresetId={props.changePresetId}
                data={data}
                refetchData={refetch}
                setRefetchPreset={setRefetchPreset}
            />
            <PPPriceSettings settingLocalstorage={props.settingLocalstorage} shops={data.shops} />
        </div>
    )
}

function PresetSettings(props) {
    const [t] = useTranslation()

    return (
        <div className="card shadow">
            <div className="card-header">
                <h2 className="card-title">{t("settings.preset.header")}</h2>
            </div>
            <div className="card-body">
                <div className="pp-preset-toolbar">
                    <button
                        id="buttonPresetCollapseEditPreset"
                        className="btn btn-outline-secondary pp-preset-toolbar-btn"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEditPreset"
                        aria-expanded="false"
                        aria-controls="collapseEditPreset">
                        <i className="fas fa-cog" /> Preset
                    </button>
                    <PPPresetSelector
                        id="selectPresetSelector"
                        presetId={props.presetId}
                        changePresetId={props.changePresetId}
                        presets={props.data.settings.presets}
                    />
                </div>
                <PPPresetView
                    presetId={props.presetId}
                    refetchData={props.refetchData}
                    changePresetId={props.changePresetId}
                    presets={props.data.settings.presets}
                    setRefetchPreset={props.setRefetchPreset}
                />
            </div>
        </div>
    )
}
